import { render, staticRenderFns } from "./reviewWidget.vue?vue&type=template&id=a825b620"
import script from "./reviewWidget.vue?vue&type=script&lang=js"
export * from "./reviewWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports